import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Left from '@material-ui/icons/KeyboardArrowLeft';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import { colors, SovosFlatButton, SovosRaisedButton } from 's1-ui';
import TitleBar from 'pages/TitleBar';
import { pageWidth } from '../../constants';
import AccountFormDisplayField from './AccountFormDisplayField';


const { buttonOrange, neutralWhite, grayMedium } = colors;

const styles = {
  infoPanel: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 50px 0'
  },
  settingsContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 30,
    maxWidth: pageWidth,
    width: 'calc(100% - 48px)',
    margin: 'auto'
  },
  myAccount: {
    fontSize: 30,
    fontWeight: 300,
    paddingRight: 20
  },
  lineTwo: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 20
  },
  b2l: {
    color: buttonOrange,
    fontSize: 18,
    fontWeight: 200,
    display: 'flex',
    alignItems: 'center'
  },
  saveEdits: {
    fontWeight: 300
  },
  flatButton: {
    'button&:not(.another):not(.annoying):not(.specificity):not(.contest)': {
      padding: 0,
      textTransform: 'none'
    }
  },
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 400
  }
};

export const UnstyledAccountSettingsDisplay = ({
  value, classes, onChange, errors, onSubmit, posting, isDirty, history, isProducer
}) => (
  <div>
    <TitleBar history={ history } />
    <div className={ classes.settingsContainer }>
      <div className={ classes.infoPanel }>
        <div>
          <SovosFlatButton
            className={ classes.flatButton }
            color={ buttonOrange }
            onClick={ () => history.push('/') }
          >
            <span className={ classes.b2l }><Icon><Left /></Icon>Back to licenses</span>
          </SovosFlatButton>
        </div>
        <div className={ classes.lineTwo }>
          <span className={ classes.myAccount }>My Account</span>
          <SovosRaisedButton
            className="CCP__AccountSettings__SaveButton"
            color={ neutralWhite }
            backgroundColor={ posting ? grayMedium : buttonOrange }
            disabled={ !isDirty }
            onClick={ onSubmit }
          >
            <span className={ classes.saveEdits }>{ posting ? <CircularProgress size={ 22 } color="inherit" /> : 'Save Edits'}</span>
          </SovosRaisedButton>
        </div>
        { value
          ? (
            <AccountFormDisplayField
              className="CCP__AccountSettings__Form"
              isProducer={ isProducer }
              value={ value }
              onChange={ onChange }
              errors={ errors }
            />
          )
          : (
            <div className={ classes.spinner }>
              <CircularProgress size={ 100 } />
            </div>
          )
        }
      </div>
    </div>
  </div>
);

UnstyledAccountSettingsDisplay.propTypes = {
  value: PropTypes.object,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  posting: PropTypes.bool,
  isDirty: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  isProducer: PropTypes.bool.isRequired
};

UnstyledAccountSettingsDisplay.defaultProps = {
  value: undefined,
  posting: undefined
};

export default withStyles(styles)(UnstyledAccountSettingsDisplay);
